/* eslint-disable perfectionist/sort-objects */
import {AddressFormEmail} from 'desktop/pages/checkout/components/addressFormEmail/addressFormEmail';
import {FormStructureType} from 'desktop/types/addressType';
import {CustomerType} from 'hostApplicationStoreType';

import {StatesType} from 'types/locationType';

import s from '../../desktop/pages/checkout/components/deliveryFormFields/deliveryFormFields.scss';

import {
    getAddressComponent,
    getCountryComponent,
    InputComponent,
    getInputOptionalComponent,
    getStateComponent,
} from './helpers/helpers';

/**
 * Returns structure based on which will be built entire delivery step form
 * @param {StatesType} states - states
 * @param {CustomerType} customer - customer
 * @param {string} countryValue - form country value
 * @return {FormStructureType} Configured structure for delivery step form
 */
export const getDeliveryFormStructure = (
    states: StatesType,
    customer: CustomerType,
    countryValue: string,
): FormStructureType => {
    const statesNumber = (states?.[countryValue] || []).length;

    const structure: FormStructureType = {
        firstName: {
            attributes: {
                'data-test-name': 'firstName',
                maxLength: 30,
                name: 'firstName',
            },
            label: '* First Name',
            className: s.narrow,
            component: InputComponent,
        },
        lastName: {
            attributes: {
                'data-test-name': 'lastName',
                maxLength: 30,
                name: 'lastName',
            },
            label: '* Last Name',
            className: s.narrow,
            component: InputComponent,
        },
        email: {
            attributes: {
                'data-test-name': 'email',
                maxLength: 50,
                name: 'email',
                type: 'email',
            },
            label: '* Email Address',
            className: s.narrow,
            component: AddressFormEmail,
        },
        phone: {
            attributes: {
                'data-test-name': 'phone',
                maxLength: 30,
                name: 'phone',
                type: 'tel',
            },
            label: '* Phone Number',
            className: s.narrow,
            component: InputComponent,
        },
        address: {
            attributes: {
                'data-test-name': 'address',
                maxLength: 100,
                name: 'address',
            },
            label: '* Address',
            className: s.wide,
            component: getAddressComponent,
        },
        other: {
            attributes: {
                'data-test-name': 'other',
                maxLength: 100,
                name: 'other',
            },
            label: 'Optional - Apt, Suite, Etc.',
            className: s.wide,
            component: getInputOptionalComponent,
        },
        city: {
            attributes: {
                'data-test-name': 'city',
                maxLength: 50,
                name: 'city',
            },
            label: '* City',
            className: s.narrow,
            component: InputComponent,
        },
        state: {
            attributes: {
                'data-test-name': 'state',
                maxLength: 30,
                name: 'state',
                statesNumber,
            },
            label: 'State/Province',
            className: s.narrow,
            component: getStateComponent,
        },
        postal: {
            attributes: {
                'data-test-name': 'postal',
                maxLength: 30,
                name: 'postal',
            },
            label: '* Zip/Postal Code',
            className: s.narrow,
            component: InputComponent,
        },
        country: {
            attributes: {
                'data-test-name': 'country',
                maxLength: 30,
                name: 'country',
            },
            label: '* Country',
            className: s.narrow,
            component: getCountryComponent,
        },
    };

    if (customer?.is_logged_in && structure.phone) {
        delete structure.email;
        structure.phone.className = s.wide;
    }

    if (states[countryValue]?.length) {
        structure.state.component = getStateComponent;
    }

    return structure;
};
